import config from "./global"

Object.assign(config, {
  appTitle: "Déliasse (dev)",
})

export default config



//////////////////
// WEBPACK FOOTER
// ./config/development.js
// module id = 253
// module chunks = 0